import React, { Component } from 'react'
import { Input, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
// import _ from 'underscore'

class SearchBox extends Component {

  state = {
    loading: true,
    query: ''
  }

  getQueryString(){

    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === 'query') {
            return decodeURIComponent(pair[1]);
        }
    }
    
    return ''

  }
  
  componentDidMount(){

    this.setState({query: this.getQueryString(), loading: false})
    
  }
  
  runSearch(){
    
    var query = this.refs.searchQuery.input.value
    window.location='/search?query='+query
  
  }
  
  render(){

    if(this.state.loading)
      return (<div></div>)

    return (
      <div className="searchBoxWrap">
        <Input
          ref="searchQuery"
          placeholder="Search..."
          suffix={<SearchOutlined />}
          onPressEnter={e => this.runSearch(e)}
          defaultValue={this.state.query}
          style={{ width: 160 }}
          size="large"
        />
        <Button type="default" size="large" onClick={e => this.runSearch(e)}>Search</Button>
      </div>
    )
  }
}

export default SearchBox